import { httpService } from '../helper';
import { constants } from '../constants';

export const doLogin = async (data) => httpService().post(`${constants.API.LOGIN}`, data, false);

export const doLoginViaEmail =  async (data) => httpService().post(`${constants.API.LOGINVIAEMAIL}`, data, false);
